'use client'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

const LoadingSpinner = ({ size = 'md', text = '' }: LoadingSpinnerProps) => {
  const sizeClasses: Record<string, string> = {
    sm: 'w-5 h-5 border-2',
    md: 'w-10 h-10 border-[3px]',
    lg: 'w-14 h-14 border-4',
  }

  return (
    <div className="flex flex-col items-center justify-center space-y-3">
      <div className={`${sizeClasses[size]} border-surface-tertiary border-t-primary rounded-full animate-spin`} />
      {text && <p className="text-text-secondary text-sm">{text}</p>}
    </div>
  )
}

export default LoadingSpinner
